import { Component, OnInit, ViewContainerRef, HostListener, ViewChild, ElementRef, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { HowitsworkHomepageComponent } from '../howitswork-homepage/howitswork-homepage.component';
import { OnDestroy } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { isPlatformServer } from '@angular/common';
import { makeStateKey, TransferState } from "@angular/platform-browser";
import { environment } from 'src/environments/environment';
import { ConstantMessages } from 'src/app/common/ConstantMessages';
import { Constants } from 'src/app/common/Constants';
import { MessageService } from 'src/app/common/message.service';
import { SeoService } from 'src/app/seo.service';
import { HTTPService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
import { windowScreen } from 'src/app/services/utility.service';
import { LoginComponent } from 'src/app/shared/components/Login/Login.component';
import { HowItWorksDialogComponent } from '../how-it-works-dialog/how-it-works-dialog.component';
import { PremiumInviteDialogComponent } from '../premium-invite-dialog/premium-invite-dialog.component';
@Component({
  selector: 'homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
  providers: [HTTPService, MessageService]
})

export class HomepageComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  siteURL = environment.siteURL;
  public constants: Constants;
  public constantMessages: ConstantMessages;
  public pageSize: any = 0;
  public messageType: any;
  public HomepageData: any;
  public videoCategoryData: any;
  public VideoFilterModel = { videoId: 0, categoryId: 0, SubcategoryId: 0, StartRow: 0, PageSize: 1200, ScreenType: 1, IsMainHomePageRequest: true }
  AllVideoData: any = []
  AllCardData: any = []
  WeddingVideoData: any = []
  EngagmentVideoData: any = []
  BirthdaysVideoData: any = []
  HouseWarmingVideoData: any = []
  BabyShowerVideoData: any = []
  NamingCeremonyVideoData: any = []
  GeneralVideoData: any = []
  FeaturedVideoData: any = ['1', '2', '3', '1', '2', '3']
  public screen: string = 'mobile';
  public isAllVideoLoading: boolean = false;
  public isAllVideoLoaded: boolean = false;
  public specialCategoryData: any;
  @ViewChild("posterVideo") posterVideo: ElementRef;
  videoIntervalId: any;
  currentDay = new Date().getDay();
  isMobileDevice: boolean;
  numberOfitemsForCard = 4;
  numberOfitemsForVideo = 8;
  customNumberOfitems = 20;
  assetURL = environment.cloudFrontAssetURL;
  activeTab = 1;
  searchterm = "";
  isShowVideo = false;
  globalListenFunc: Function;
  contentVisibility = [
    false, false, false, false, false, false
  ];
  masterSubCategory: any = [];
  additionalSubCategory: any = [];
  //{{assetURL}}/assets/Video/Desktop_Video2.mp4
  owlOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    margin: 0,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    navText: ['', ''],
    stagePadding: 0,
    dotsEach: false,
    freeDrag: true,
    responsive: {
      0: {
        items: 1
      },
      560: {
        items: 1
      },
      768: {
        items: 2
      },
      1100: {
        items: 4
      },
      1700: {
        items: 5
      }
    },
    nav: true
  }
  constructor(private dialog: MatDialog, private renderer: Renderer2, public sharedService: SharedService,
    private _httpService: HTTPService, private _router: Router,
    private messageService: MessageService, public toastr: ToastrService,
    vcr: ViewContainerRef, private deviceService: DeviceDetectorService,
    private modalService: NgbModal, private seoService: SeoService, public activeModal: NgbActiveModal,
    @Inject(PLATFORM_ID) private platformId, private transferState: TransferState) {
    this.constants = new Constants();
    this.constantMessages = new ConstantMessages();
    this.messageType = this.constants.messageType;
    if (!isPlatformServer(this.platformId)) {
      window.addEventListener('resize', this.handleWindowResize);
    }
  }

  ngAfterViewInit() {
    if (!isPlatformServer(this.platformId)) {
      this.videoIntervalId = setInterval(() => {
        this.isShowVideo = true;
        if (this.posterVideo != undefined) {
          const media = this.posterVideo.nativeElement;
          media.muted = true; // without this line it's not working although I have "muted" in HTML
          media.play()
        }
      }, 5000);
    }
  }

  editForMe() {
    // const modelRef = this.modalService.open(HowItWorksDialogComponent, {
    //   size: 'lg'
    // });
    let encryptedqueryparams: { templateId: any, invitationType: any };
    encryptedqueryparams = {
      templateId: 1000,
      invitationType: 1
    };
    this._router.navigate([`/personalise/custom-video/videoforme/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`]);
  }
  premiumInvites() {
    const modelRef = this.modalService.open(PremiumInviteDialogComponent, {
      size: 'lg'
    });
  }

  ngOnInit() {
    this.seoService.generateTags({
      title: `Online Invitation Maker | Invitation Maker | 247 Invites`,
      description: `247 Invites Online Invitation Maker is your online solution for every event. Create Video invitations for Weddings Birthdays and for Events. Create Now!`,
      image: `${this.assetURL}/assets/images/logo.png`,
      keywords: "online invitation maker, invitation maker online, birthday invitation video maker online, Online Video Invitation Maker"
    });
    //this.login();
    //this.GetHomepageDataList();
    this.isMobileDevice = this.deviceService.isMobile();
    this.sharedService.isPageDataLoaded = false;
    if (!isPlatformServer(this.platformId))
      this.handleWindowResize();
    if (this.isMobileDevice)
      this.numberOfitemsForCard = 4;
    if (this.sharedService.videoCategoryData != undefined) {
      this.videoCategoryData = this.sharedService.videoCategoryData;
      this.loadMasterSubCategory();
      this.loadAdditionalSubCategory();
    } else {
      this.sharedService.isVideoCategoryDataAvailable.subscribe(
        (data: any) => {
          if (data) {
            this.loadMasterSubCategory();
            this.loadAdditionalSubCategory();
          }
        }
      );
    }
  }

  handleWindowResize = (): void => {
    this.screen = windowScreen();
  }

  private loadMasterSubCategory() {
    this.videoCategoryData = this.sharedService.videoCategoryData;
    this.videoCategoryData.forEach(categoryItem => {
      this.masterSubCategory.push(...categoryItem.SubCategoryData.filter(x => x.IsMaster == true));
    });
  }
  private loadAdditionalSubCategory() {
    this.videoCategoryData = this.sharedService.videoCategoryData;
    this.videoCategoryData.forEach(categoryItem => {
      this.additionalSubCategory.push(...categoryItem.SubCategoryData.filter(x => x.IsMaster !== true));
    });
  }

  openHowitWorks(): void {
    const modalReference = this.modalService.open(HowitsworkHomepageComponent, {
      size: "lg",
      centered: true,
      backdrop: "static"
    });
  }

  public GetHomepageDataList() {

    if (this.isAllVideoLoading) return false;
    this.isAllVideoLoading = true;
    const HomePage_Key = makeStateKey("HomePage_Key");

    // this.AllVideoData = this.homedata1.homepageData;
    if (this.transferState.hasKey(HomePage_Key)) {
      const data = this.transferState.get(HomePage_Key, null);
      if (!isPlatformServer(this.platformId)) {
        this.transferState.remove(HomePage_Key);
      }
      this.processHomePageData(data);
    }
    else {
      this.subscription.add(
        this._httpService.ajaxPost('homepage/GetHomepageData', this.VideoFilterModel).subscribe(
          data => {
            if (isPlatformServer(this.platformId)) {
              this.transferState.set(HomePage_Key, data);
            }
            this.processHomePageData(data);
          },
          (error: any) => {
            // this.hideSpinner();
            // this.messageService.showMessage(this.constErrors.CommonError, this.messageType.Error);
          }));
    }
    // this.FeaturedVideoData = this.homedata1.homepageData;
    // this.AllVideoData = this.homedata1.homepageData;
  }

  private processHomePageData(data: any) {
    this.sharedService.isShowLoader.next(false);
    if (data["Message"].MessageTypeValue == this.messageType.Success) {

      var allVideoData = data["AllVideoData"];
      if (allVideoData != null && allVideoData.length > 0) {
        allVideoData.forEach(element => {
          this.AllVideoData.push(element);
        });
      }
      var allCardData = data["AllCardData"];
      if (allCardData != null && allCardData.length > 0) {
        allCardData.forEach(element => {
          this.AllCardData.push(element);
        });
      }
      if (data["FeaturedVideoData"] != null && data["FeaturedVideoData"].length > 0) {
        this.FeaturedVideoData = data["FeaturedVideoData"];
      }
    }
    else if (data["Message"].MessageTypeValue == 6) {
      this.isAllVideoLoaded = true;
    }
    else {
      this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
    }

    this.isAllVideoLoading = false;
  }

  bottomReached(): boolean {
    return Math.round(window.innerHeight + window.scrollY) + 2 >= document.body.offsetHeight;
  }

  @HostListener("window:scroll", [])
  onScroll(): void {
    if (!isPlatformServer(this.platformId)) {
      const bottomReached = Math.round(window.innerHeight + window.scrollY) + 2 >= document.body.offsetHeight;
      if (this.bottomReached()) {
        if (this.isAllVideoLoaded) return;
        this.VideoFilterModel.StartRow = this.AllVideoData.length;
        this.VideoFilterModel.IsMainHomePageRequest = false;
        this.GetHomepageDataList();
        this.sharedService.isPageDataLoaded = true;
      }
    }
  }

  openDialog(): void {
    this.dialog.open(LoginComponent)
  }
  getCategoryVideo(item) {
    // if(this.isMobile)
    // {
    //  this.toggleMenu();
    // }
    if (item.Sub_Category_Id > 0) {
      let encryptedqueryparams: { categoryId: any, subCategoryId: any };
      encryptedqueryparams = {
        categoryId: item.Category_Id,
        subCategoryId: item.Sub_Category_Id
      };
      this._router.navigate([`${item.Category_Desc.replace(/ +/g, "-")}/${item.More_Category_Desc.replace(/ +/g, "-")}/videos-invitation-maker/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`]);
    }
    else {
      let encryptedqueryparams: { categoryId: any, subCategoryId: any };
      encryptedqueryparams = {
        categoryId: item.Category_Id,
        subCategoryId: 0
      };
      this._router.navigate([`${item.Category_Desc.replace(/ +/g, "-")}/videos-invitation-maker/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`]);
    }

    // if (pathString == "/videocategory") {
    //   location.reload();
    // }
    // else {
    //   this._router.navigate(['/videocategory']);
    // }

  }
  activeVideoBasedOnDay(videoType: number) {
    if (new Date().getDay() == 0 || new Date().getDay() == 2 || new Date().getDay() == 4 || new Date().getDay() == 6) {
      if (videoType == 1) {
        return true;
      }
      else {
        return false;
      }
    }
    else {

    }
  }
  // public openVideoPage(item) {
  //   this._router.navigate(['/videopage', { videoId: item.VideoId }]);
  // }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getVideoData(categoryId: number) {
    return this.AllVideoData.filter(x => x.CategoryId == categoryId).slice(0, 5);
  }
  getCardData(categoryId: number) {
    return this.AllCardData.filter(x => x.CategoryId == categoryId).slice(0, 5);
  }
  addLog() {
    this.changeActiveTab(2);
    let objLog = Object.assign({});
    objLog.UserId = 0;
    objLog.MethodName = "CardHomePage";
    objLog.IsSuccess = true;
    objLog.Description = "User clicked on card on home page.";
    objLog.IPAddress = this.sharedService.ipAddress;
    this.subscription.add(
      this._httpService.ajaxPost('Personalize/AddLog', objLog).subscribe((data) => {
      }));
  }
  changeActiveTab(tabId: number) {
    this.activeTab = tabId;
  }
  search() {
    this.subscription.add(
      this._httpService.ajaxPost(`search/isSerchResultAvailable?searchterm=${this.searchterm}`, null).subscribe(
        data => {
          if (data) {
            this._router.navigate([`user/search/${this.searchterm}`]);
          }
          else {
            this.toastr.error(`No result available for given search. Please look into relevant category becuase your search for ${this.searchterm} might available under different title.`);
          }
        },
        (error: any) => {

        }));
  }
  keyPress(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this.search();
    }
  }
  changeContentVisibility(id: number) {
    this.contentVisibility[id] = !this.contentVisibility[id];
  }
}